// ระบบงาน (มอบหมายงาน) — /api/tasks · migration 080
import { apiSlice } from "./apiSlice";
import { TASKS_URL } from "../constants";

// มีไฟล์แนบ → ส่งเป็น multipart (FormData) · ไม่มี → JSON ปกติ
const withFiles = (fields, files) => {
  if (!files?.length) return fields;
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== "") fd.append(k, v);
  });
  files.forEach((f) => fd.append("files", f));
  return fd;
};

export const taskApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTaskMeta: builder.query({
      query: () => `${TASKS_URL}/meta`,
      providesTags: ["Task"],
    }),
    getTasks: builder.query({
      query: (params) => ({ url: TASKS_URL, params }),
      providesTags: ["Task"],
    }),
    getTask: builder.query({
      query: (id) => `${TASKS_URL}/${id}`,
      providesTags: ["Task"],
    }),
    getTaskCodes: builder.query({
      query: (q) => ({ url: `${TASKS_URL}/codes`, params: q ? { q } : undefined }),
      keepUnusedDataFor: 60,
    }),
    createTask: builder.mutation({
      query: ({ files, ...fields }) => ({ url: TASKS_URL, method: "POST", body: withFiles(fields, files) }),
      invalidatesTags: ["Task"],
    }),
    updateTask: builder.mutation({
      query: ({ id, ...body }) => ({ url: `${TASKS_URL}/${id}`, method: "PUT", body }),
      invalidatesTags: ["Task"],
    }),
    changeTaskStatus: builder.mutation({
      query: ({ id, status, reason }) => ({ url: `${TASKS_URL}/${id}/status`, method: "POST", body: { status, reason } }),
      invalidatesTags: ["Task"],
    }),
    claimTask: builder.mutation({
      query: (id) => ({ url: `${TASKS_URL}/${id}/claim`, method: "POST" }),
      invalidatesTags: ["Task"],
    }),
    addTaskComment: builder.mutation({
      query: ({ id, message, files }) => ({ url: `${TASKS_URL}/${id}/comments`, method: "POST", body: withFiles({ message }, files) }),
      invalidatesTags: ["Task"],
    }),
    // ตีกลับก้อนก่อนหน้า (ก้อนงานโปรเจกต์) — แนบหลักฐานได้ · utils/taskPlan.js
    rejectTask: builder.mutation({
      query: ({ id, files, ...fields }) => ({ url: `${TASKS_URL}/${id}/reject`, method: "POST", body: withFiles(fields, files) }),
      invalidatesTags: ["Task"],
    }),
    getRunSteps: builder.query({
      query: (runId) => `${TASKS_URL}/run/${runId}`,
      providesTags: ["Task"],
    }),
    planRun: builder.mutation({
      query: ({ runId, ...body }) => ({ url: `${TASKS_URL}/run/${runId}/plan`, method: "POST", body }),
      invalidatesTags: ["Task"],
    }),
    getTaskTemplates: builder.query({
      query: () => `${TASKS_URL}/templates`,
      providesTags: ["Task"],
    }),
    createTaskTemplate: builder.mutation({
      query: (body) => ({ url: `${TASKS_URL}/templates`, method: "POST", body }),
      invalidatesTags: ["Task"],
    }),
    updateTaskTemplate: builder.mutation({
      query: ({ id, ...body }) => ({ url: `${TASKS_URL}/templates/${id}`, method: "PUT", body }),
      invalidatesTags: ["Task"],
    }),
    deleteTaskTemplate: builder.mutation({
      query: (id) => ({ url: `${TASKS_URL}/templates/${id}`, method: "DELETE" }),
      invalidatesTags: ["Task"],
    }),
  }),
});

export const {
  useGetTaskMetaQuery,
  useGetTasksQuery,
  useGetTaskQuery,
  useGetTaskCodesQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useChangeTaskStatusMutation,
  useClaimTaskMutation,
  useAddTaskCommentMutation,
  useRejectTaskMutation,
  useGetRunStepsQuery,
  usePlanRunMutation,
  useGetTaskTemplatesQuery,
  useCreateTaskTemplateMutation,
  useUpdateTaskTemplateMutation,
  useDeleteTaskTemplateMutation,
} = taskApiSlice;
